/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const AddEventCategory = () => {
    const [formData, setFormData] = useState({
        name: '',
        is_active: true
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.name) {
            toast.error("Category Name is required!");
            return;
        }

        setLoading(true);

        try {
            await postRequest('event-categories', formData);
            toast.success('Category added successfully!');
            navigate('/events/categories');
        } catch (error) {
            console.error('Failed to add category:', error);
            toast.error(error?.message || 'Error occurred while creating category.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='container-fluid mt-5 mb-5'>
            <div className='mainheadig mx-4 mb-4 d-flex justify-content-between align-items-center'>
                <h4 className='text-white font-weight-bold'>Add Event Category</h4>
                <button className="btn btn-light font-weight-bold" onClick={() => navigate('/events/categories')}>Back to List</button>
            </div>
            <form onSubmit={handleSubmit} className="mx-4 p-4 card shadow">
                <div className='row'>
                    <div className='col-md-6 form-group'>
                        <label className='admin-label font-weight-bold'>Category Name *</label>
                        <input 
                            type='text' 
                            name='name' 
                            className='form-control' 
                            value={formData.name} 
                            onChange={handleChange} 
                            placeholder='e.g., Summit'
                        />
                    </div>
                    <div className='col-md-6 form-group d-flex align-items-center mt-4'>
                        <div className="custom-control custom-checkbox">
                            <input 
                                type="checkbox" 
                                name='is_active' 
                                className="custom-control-input" 
                                id="statusCheckbox"
                                checked={formData.is_active}
                                onChange={handleChange}
                            />
                            <label className="custom-control-label admin-label font-weight-bold" htmlFor="statusCheckbox">Active Status</label>
                        </div>
                    </div>
                </div>
                <div className="text-center mt-4">
                    <button 
                        type="submit" 
                        className="btn btn-primary px-5 py-2 font-weight-bold" 
                        disabled={loading}
                    >
                        {loading ? 'Submitting...' : 'Submit'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddEventCategory;
